import React from "react";
import routeGuard from "src/HOC/routeGuard";
import GNCSimulatorList from "src/components/GNCSimulator/list";
import { RESOURCE_TYPE } from "src/constant/common";

const GNCSimulator = () => {
  return <GNCSimulatorList />;
};

export default routeGuard(GNCSimulator, RESOURCE_TYPE.GNC_SIMULATION);
